export default {
  license: {
    license_manage_title: '許可證管理',
    btn_apply: '申請許可證',
    btn_import: '導入許可證',
    probation_title: '您處於正常使用中',
    probation_desc: '當前軟件為試用期，為不影響您的使用效果，請與 {date} 前導入有效的許可證',
    probation_over_desc: '您的試用期已過，請導入有效的許可證',
    upload_format_error: '請導入.lic文件',
    upload_lic_success: '導入成功！',
    upload_lic_fail: '導入失敗！',
    license_expired: '許可證已到期，請聯繫管理員申請授權',
    license_probation_expired: '已過試用期，請聯繫管理員申請許可證',
    license_popup_title: '提示信息',
    client: {
      client_info_title: '客戶信息',
      owner: '許可證所有人',
      status: '狀態',
      id: '許可證序列號',
      generate_date: '生成日期',
      valid_date: '有效日期',
      product: '授權產品',
      robot_num: '授權機器人數量',
      used_robot: '已使用機器人數量',
      authorized_info: '授權信息',
      expired: '已過期',
      valid: '有效',
      open: '開啟',
      close: '關閉',
      faq_amount: 'FAQ數量',
      kg_entity: 'KG實體',
      te_scenerio: 'TE場景',
      chat_function: '閒聊功能',
      ner_function: 'NER功能',
      function: '技能發現',
      probation_expired: '試用期結束',
      probation_valid: '試用期有效',
      license_expired: '已過期',
      license_valid: '有效',
      authorized_list_title: '授權產品列表',
    },
    authorized_status: {
      title: '授權使用狀態',
      robot_used_status: '授權機器人總數{total}個 已使用{num}個',
      robot_name: '機器人名稱',
      robot_num: '機器人數量',
      user_name: '用戶名',
      amount: '使用量',
      opened: '已開啟',
      not_open: '未開啟',
      used: '已使用',
      not_use: '未使用',
      concurrent: '並發數量',
      total_file_count: '總文件數',
      amount_per_day: '每天最大文件數',
      total_length: '總時長(h)',
      length_per_day: '每天最大時長(h)',
      online_num: '坐席在線數量',
      short_text: '短文本標註',
      long_text: '長文本標註',
      daily_call: '每日調用次數',
      tts_num: '語音識別數量',
      asr_num: '語音合成數量',
    },
    apply: {
      popup_title: '許可證申請',
      apply_steps: '申請步驟',
      steps: '["1. 點擊按鈕生成機器碼", "2. 將機器碼發送給你的客戶經理", "3. 竹間許可證管理員會在收到機器碼3個工作日內，核實信息之後生成許可證，發送至您郵箱", "4. 您查收郵件後下載許可證書，在BFOP平臺上傳導入"]',
      generate_code: '生成機器碼',
      generating_code: '機器碼生成中',
      generate_success: '生成成功！',
      generate_fail: '生成失敗！',
      machine_code: '機器碼',
      generated_tips: '機器碼已生成，請進行複製/下載後將機器碼信息發送至support@emotibot.com 會有工作人員處理後郵件回復進度',
      generated_tips_fail: '機器碼生成失敗,請十分鐘之後重試',
      file_name: '授權碼',
      copy_success: '複製成功',
      empty_code: '機器碼為空！',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/zh-tw-license.js